import React, { createContext, useEffect, useMemo, useState } from "react";

export const AuthContext = createContext(null);

const LS_USER_KEY = "auth.user";
const LS_TOKEN_KEY = "auth.token";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);        // { id, username, group_role, organization: {...} }
  const [token, setToken] = useState(null);      // JWT or session token string
  const [loading, setLoading] = useState(true);

  // Initialize from localStorage so new tabs are logged in
  useEffect(() => {
    try {
      const u = localStorage.getItem(LS_USER_KEY);
      const t = localStorage.getItem(LS_TOKEN_KEY);
      if (u && t) {
        setUser(JSON.parse(u));
        setToken(t);
      }
    } catch (_) {}
    setLoading(false);
  }, []);

  // Keep localStorage in sync
  useEffect(() => {
    if (user) localStorage.setItem(LS_USER_KEY, JSON.stringify(user));
    else localStorage.removeItem(LS_USER_KEY);
  }, [user]);

  useEffect(() => {
    if (token) localStorage.setItem(LS_TOKEN_KEY, token);
    else localStorage.removeItem(LS_TOKEN_KEY);
  }, [token]);

  const login = (nextUser, nextToken) => {
    setUser(nextUser);
    setToken(nextToken);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    // optional: also clear per-tab state like selected org
    // localStorage.removeItem("selectedOrgId");
  };

  const value = useMemo(
    () => ({
      user,
      token,
      isAuthenticated: Boolean(user && token),
      login,
      logout,
    }),
    [user, token]
  );

  if (loading) return null; // or splash screen
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
